import {productsOrderTableSettings, ProductsOrderTableSettings} from '../../../bps/components/productsOrderTable/productsOrderTableSettings';

productsOrderTableSettings.animationName = 'vue-animation--fade';
productsOrderTableSettings.animationDuration = '.8s';

export {productsOrderTableSettings, ProductsOrderTableSettings};
